import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import V2UsersList from '../admin/V2UsersList';
import V2AdminPageHeading from '../components/V2AdminPageHeading';

const V2Users: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <V2AdminPageHeading
        title={t('admin_users_title')}
        description={t('admin_users_description')}
        action={
          <Link className="outline-button v2-admin-page-heading__action" to="/admin/referrals">
            {t('admin_users_referrals')}
          </Link>
        }
      />
      <div className="v2-admin-users">
        <V2UsersList />
      </div>
    </>
  );
};

export default V2Users;
